import { CircularProgress, Grid2, IconButton, Skeleton, Tab, Tabs, Typography } from '@mui/material'
import React, { memo, useEffect, useMemo, useState } from 'react'
import Container from '../../../components/Container'
import { Add, ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import ServiceCard from '../../../components/Cards/ServiceCard'
import ServiceCardSkeleton from '../../../components/Skeletons/ServiceCardSkeleton'
import { useLocation, useNavigate } from 'react-router-dom'
import { useApp } from '../../../contexts/AppContext'
import api from '../../../utils/axios'
import { IBranch, IService } from 'sierra'
import socket from '../../../utils/socket'

const Services = memo(() => {
    const navigate = useNavigate()
    const location = useLocation()
    const { lang, translate } = useApp()

    const branch: IBranch = useMemo(() => location.state?.branch, [location])

    const [services, setServices] = useState<IService[] | null>(null)
    const [branches, setBranches] = useState<IBranch[] | null>(null)
    const [selectedBranch, setSelectedBranch] = useState<number | null>(branch?.branch_id || null)

    const fetchBranches = () => {
        api.get('/branches').then(res => {
            setBranches(res.data)
            if (!branch?.branch_id) setSelectedBranch(res.data[0].branch_id)
        }).catch(console.error)
    }

    const fetchServices = () => {
        api.get('/services').then(res => {
            setServices(res.data)
            console.log(res.data);
        }).catch(console.error)
    }


    useEffect(() => {
        fetchServices()
        fetchBranches()
        socket.on("branches_changed", fetchBranches);
        socket.on("branches_changed", fetchServices);
        socket.on("translations_changed", fetchBranches);
        socket.on("translations_changed", fetchServices);
        return () => {
            socket.off("branches_changed", fetchBranches);
            socket.off("branches_changed", fetchServices);
            socket.off("translations_changed", fetchBranches);
            socket.off("translations_changed", fetchServices);
        }
    }, [])

    return (
        <Grid2 container size={'grow'} flexDirection={'column'} spacing={2}>

            <Container container size={'auto'} padding={{ xs: 1, sm: 2 }} display={'flex'} alignItems={'center'}>
                <Grid2>
                    <IconButton onClick={() => navigate('/')} color="primary" disableRipple>
                        {lang === 'ar' ? <ArrowForwardIos /> : <ArrowBackIos />}
                    </IconButton>
                </Grid2>
                <Grid2>
                    <Typography variant='h5' fontWeight={'bold'} color='primary'>
                        {translate("Select service:")}
                    </Typography>
                </Grid2>
            </Container>

            <Container container padding={{ xs: 1, sm: 2 }} spacing={2} width={'100%'} size='auto' alignItems={'center'} >
                {
                    !branches ? Array.from({ length: 3 }).map((a, i) => <Grid2 key={i} width={{ xs: 75, md: 150 }}><Skeleton variant="rounded" width={'100%'} height={50} /></Grid2>) : branches.length === 0 ? <></> :
                        <Grid2>
                            <Tabs variant='scrollable' value={selectedBranch || branches && branches[0].branch_id} onChange={(_, v) => setSelectedBranch(v)} aria-label="basic tabs example">
                                {branches.map((b, i) =>
                                    <Tab key={i} label={b.branch_name[lang]} value={b.branch_id} />
                                )}
                            </Tabs>
                        </Grid2>

                }
            </Container>

            <Container container flexDirection={'column'} overflow={'hidden'} spacing={2} padding={2}>

                <Grid2 container padding={2} overflow={'auto'}>
                    {!branches || !services || !selectedBranch ?
                        Array.from({ length: 3 }).map((a, i) => <ServiceCardSkeleton hideButtons key={i} />)
                        : branches.length == 0 || services.length == 0 ? <Typography>No services</Typography> :
                            services
                                // .concat(services)
                                .filter(s => s.branch_id === selectedBranch)
                                .map((s, i) => <ServiceCard clickable hideButtons branches={branches} key={i} service={s} branch={branches.find(b => b.branch_id === s.branch_id)} />)}
                </Grid2>
            </Container>

        </Grid2>)
})

export default Services